// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__3_4WN","colMin":"styles_colMin__1Ezt7","colCheckbox":"styles_colCheckbox__FKWKz"};